export const baseUrl = () => {
  if (
    window.location.host.includes("localhost") ||
    window.location.host.includes("iranademo") ||
    window.location.host.includes("192.168")
  ) {
    return `https://tabriz.backend1.azarpark.irana.app/`;
    // return `https://bilitbackend.iranademo.ir/`;
    // return `http://192.168.1.104:8000/`;
  }
  return `https://tabriz.backend1.azarpark.irana.app/`;
  // return `https://ticket.irana.app/backend1/`;
};

export default {
  baseUrl,
};
